<!-- <div class="sh-header__interface sh-interface" style="margin-bottom: 6%">
  <label class="sh-interface__item sh-search sh-search--interface sh-search--expandable sh-main-search sh-search--open" style="">
    <input class="sh-search__input" type="search" autocomplete="off">
    <div class="sh-search__icon sh-icon sh-icon--search"></div>
  <div class="autocomplete-suggestions" style="position: absolute; display: none; max-height: 415px; z-index: 200;"></div></label>
</div> -->
<sh-input-text label='Search'></sh-input-text>
<!-- <tree [tree]="tree" (nodeSelected)="logEvent($event)"></tree> -->
<div class="val-tree">
  <tree-root class="color-white" *ngIf="search; else personal"
  #tree
  (initialize)="onInit(tree)"
  [(state)]="state"
  [nodes]="nodes" 
  id = "foldertree"
  [options]="options" 
  (toggleExpanded)="onNodeToggled($event)"
  (activate)="onNodeSelect($event)">
</tree-root>
<ng-template #personal>
    <tree-root class="color-white"
    #tree
    (initialize)="onInit(tree)"
    [(state)]="state1"
    [nodes]="nodes" 
    [options]="options" 
    (toggleExpanded)="onNodeToggled($event)"
    (activate)="onNodeSelect($event)">
    </tree-root>
</ng-template>
</div>